import { AppAreaConfig } from '@/funnels/@types'
import maleTaiChiWalking from './activity-male-tai-chi-walking'
import femaleTaiChiWalkingPr from './activity-female-tai-chi-walking-pr'

const appAreaConfig: AppAreaConfig = {
	appArea: 'main-tai-chi-walking-pr',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['tai_chi_walking'],
	},
	landing: {
		ids: ['loader-tai-chi-walking', 'age-tai-chi-walking-pr'],
		route: {
			path: '/tai-chi-walking-pr',
			name: 'main-tai-chi-walking-pr-funnel',
		},
	},
	funnel: {
		id: 'ob-tai-chi-walking-gender-selection-pr',
		route: {
			path: '/tai-chi-walking-pr/ob/:page(.*)?',
			name: 'main-tai-chi-walking-pr',
		},
		slug: 'main-tai-chi-walking-pr',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
		redirectTo: {
			sex: {
				male: { appArea: maleTaiChiWalking },
				female: { appArea: femaleTaiChiWalkingPr },
			},
		},
	},
}

export default appAreaConfig
